import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { QA_NAME_CLEAR_BTN } from '../../../constants/qa'
import Button from '../../Button'

function FormButtonClear({
  Component = Button.Outlined,
  height = 32,
  qaName = QA_NAME_CLEAR_BTN,
  title = 'Modal.ClearBtnKey',
  tooltipPlacement = FLOATING_ELEMENT_PLACEMENT.top,
  tooltipTitle = 'Modal.ClearBtnTooltipKey',
  ...restProps
}) {
  const { t } = useTranslation()

  return (
    <Component
      {...restProps}
      height={height}
      qaName={qaName}
      text={t(title)}
      tooltip={t(tooltipTitle)}
      tooltipPlacement={tooltipPlacement}
    />
  )
}

export default FormButtonClear
